// extracted by mini-css-extract-plugin
export default {"home":"home__uRcqa","category":"category__RhR1k","empty":"empty__fAXte","emptyText":"emptyText__vuuVO","editLink":"editLink__7nFFD"};